import {
  Component,
  Injector,
  Input,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  HostListener,
} from "@angular/core";
import { DatePipe } from "@angular/common";
import { TransactionsService } from "@services/entity/transactions.service";
import { AuthenticationService } from "@services/authentication/authentication.service";
import { SupportTicketRequest } from "@dto/supportTicketRequest";
import { TransactionDto } from "@dto/transactionDto";
import { ToastService } from "@services/toast/toast.service";
import { ChargingStationsService } from "@services/entity/charging-stations.service";

@Component({
  selector: "request-support-popup",
  templateUrl: "./request-support-popup.component.html",
  styleUrls: ["./request-support-popup.component.scss"],
})
export class RequestSupportPopupComponent {
  @Input() transaction: TransactionDto;
  @Input() isOpen: boolean = false;
  @Output() isClosing: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild("supportMessageTextarea")
  supportMessage: ElementRef<HTMLTextAreaElement>;

  public isOperator: boolean;
  public isCustomer: boolean;
  public isUser: boolean;
  public ticket: SupportTicketRequest;
  public isSending: boolean;

  constructor(
    private authenticationService: AuthenticationService,
    private toastService: ToastService,
    public chargingStationsService: ChargingStationsService,
    public datePipe: DatePipe,
    public injector: Injector
  ) {}

  ngOnInit(): void {
    this.isSending = false;
    this.ticket = new SupportTicketRequest();

    if (this.authenticationService.userHasRole("Operator"))
      this.isOperator = true;
    if (this.authenticationService.userHasRole("Customer"))
      this.isCustomer = true;
    if (this.authenticationService.userHasRole("User")) this.isUser = true;

    this.supportMessage = null;
  }

  close() {
    this.isClosing.emit(true);
  }

  onValueChange(event: Event): void {
    const value = (event.target as any).value;
    this.ticket.customerEnteredText = value;
  }

  send() {
    this.isSending = true;

    this.createSupportTicket();
    this.close();
  }

  reset() {
    this.isSending = false;
    this.ticket = new SupportTicketRequest();

    if (this.supportMessage) {
      this.supportMessage.nativeElement.value = "";
    }
  }

  createSupportTicket() {
    this.ticket.chargingStationID = this.transaction.chargingStationId;
    this.ticket.chargingStationName = this.transaction.chargingStationName;
    this.ticket.emailSubject =
      "Support und Feedback am Ladevorgang " + this.transaction.id;
    this.ticket.senderName =
      this.authenticationService.getLoggedInUser().fullName;
    this.ticket.senderEmail =
      this.authenticationService.getLoggedInUser().email;
    this.toastService.loading(
      "Daten für die Fehleranalyse werden gesammelt...",
      true
    );
    this.ticket.diagnostics = true;

    this.sendSupportTicket();
  }

  sendSupportTicket() {
    this.chargingStationsService
      .sendSupportTicket(this.ticket, this.transaction.chargingStationId)
      .subscribe(
        (result) => {
          this.toastService.success("Ihre Anfrage wurde versandt.", 7500, true);
          this.reset();
        },
        (error) => {
          this.toastService.error(
            "Anfrage konnte nicht gesendet werden.",
            7500,
            true
          );
          this.reset();
          console.error(error);
        }
      );
  }

  matches(entity: TransactionDto, term: string) {
    return TransactionsService.matches(entity, term);
  }

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.key === "Enter") {
      this.send();
    }
  }
}
